function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

function getAvatarColor(user) {
  const seed = user.uid || user.email || user.displayName || '?';
  const hue = hashString(seed) % 360;
  return `hsl(${hue}, 60%, 42%)`;
}

function isUserOnline(user) {
  if (user.status !== 'online') return false;
  const lastSeen = user.lastSeen?.toDate ? user.lastSeen.toDate() : new Date(user.lastSeen);
  return (Date.now() - lastSeen.getTime()) < 120000; // 2 minutes
}

export default function UserAvatar({ user, size = 28, showStatus = true }) {
  if (!user) return null;

  const name = user.displayName || user.email || '?';
  const initial = name.charAt(0).toUpperCase();
  const bgColor = getAvatarColor(user);
  const online = isUserOnline(user);
  const dotSize = Math.max(8, size * 0.3);

  return (
    <div
      className="user-avatar"
      style={{ width: size, height: size, fontSize: size * 0.45 }}
      title={`${name}${showStatus ? (online ? ' (online)' : ' (offline)') : ''}`}
    >
      <div className="user-avatar-circle" style={{ backgroundColor: user.photoURL ? 'transparent' : bgColor }}>
        {user.photoURL ? (
          <img src={user.photoURL} alt={name} className="user-avatar-img" />
        ) : (
          initial
        )}
      </div>
      {showStatus && (
        <span
          className={`user-avatar-dot ${online ? 'online' : 'offline'}`}
          style={{ width: dotSize, height: dotSize }}
        />
      )}
    </div>
  );
}

export { isUserOnline };
